/**
 * AttachInvoiceModal — closes the PO loop (received → invoiced).
 * Issue #130 / #106.
 */

import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { attachInvoiceToPurchase } from '../../services/purchaseOrderService';
import { toast } from '../../utils/toast';

const today = () => new Date().toISOString().slice(0, 10);

const AttachInvoiceModal = ({ show, onHide, purchase, onAttached }) => {
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [invoiceDate, setInvoiceDate] = useState(today());
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!show) return;
    setInvoiceNumber('');
    setInvoiceDate(today());
    setError(null);
  }, [show]);

  const handleSubmit = async () => {
    setError(null);
    if (!invoiceNumber.trim()) {
      setError('El número de factura es requerido.');
      return;
    }
    if (!invoiceDate) {
      setError('La fecha de factura es requerida.');
      return;
    }
    setSubmitting(true);
    const { error: err, data } = await attachInvoiceToPurchase({
      purchase_id: purchase.id,
      invoice_number: invoiceNumber.trim(),
      invoice_date: invoiceDate
    });
    setSubmitting(false);
    if (err) {
      setError(err.message || 'Error al adjuntar factura');
      toast.error('Error al adjuntar factura');
      return;
    }
    toast.success('Factura adjuntada — PO cerrada');
    if (onAttached) onAttached(data);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="bi bi-receipt text-primary me-2"></i>
          Adjuntar factura
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small">
          Al adjuntar la factura, la PO queda cerrada con estado{' '}
          <strong>Facturada</strong>.
        </p>
        <Form.Group className="mb-3">
          <Form.Label>
            Número de factura <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="text"
            value={invoiceNumber}
            onChange={(e) => setInvoiceNumber(e.target.value)}
            placeholder="Ej. F-1234"
            autoFocus
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>
            Fecha de factura <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            type="date"
            value={invoiceDate}
            onChange={(e) => setInvoiceDate(e.target.value)}
          />
        </Form.Group>
        {error && (
          <Alert variant="danger" className="mb-0">
            <i className="bi bi-exclamation-triangle me-2"></i>{error}
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={submitting}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={submitting}>
          {submitting ? (
            <><Spinner size="sm" className="me-2" />Procesando...</>
          ) : (
            <><i className="bi bi-check2-circle me-2"></i>Adjuntar y cerrar</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AttachInvoiceModal;
